<form [formGroup]="loginForm"
      (ngSubmit)="onSubmit()"
      class="login__form"
>
  <div class="input-text"
       [hidden]="isSirius"
       [ngClass]="{'input-text--error': isErrorVisible('roomName', 'required')
         || isErrorVisible('roomName', 'pattern')
         || isErrorVisible('roomName', 'minlength')
       }"
  >
    <input type="text" class="input-text__field"
           formControlName="roomName"
           placeholder="Please enter room name"
           spellcheck="false"
           (keypress)="isLegalChapter($event)"
    >
    <div class="input-text__placeholder">Room name</div>
    <div class="input-text__error"
         *ngIf="isErrorVisible('roomName', 'required')"
    >
      Required field. Only letters, digits, dash and underscore.
    </div>
    <div class="input-text__error"
         *ngIf="isErrorVisible('roomName', 'pattern')"
    >
      Room name should contain only letters, digits, dash and underscore.
    </div>
    <div class="input-text__error"
         *ngIf="isErrorVisible('roomName', 'minlength')"
    >
      Room name should be at least 3 characters.
    </div>
  </div>
  <div class="input-text"
       [ngClass]="{'input-text--error': isErrorVisible('userName', 'required')
          || isErrorVisible('userName', 'minlength')
       }"
  >
    <input type="text"
           class="input-text__field"
           formControlName="userName"
           placeholder="Please enter your name"
           spellcheck="false"
    >
    <div class="input-text__placeholder">Your name</div>
    <div class="input-text__error"
         *ngIf="isErrorVisible('userName', 'required')"
    >
      Required field.
    </div>
    <div class="input-text__error"
         *ngIf="isErrorVisible('userName', 'minlength')"
    >
      Name should be at least 3 characters.
    </div>
  </div>
  <button type="submit"
          class="button button--create-room"
  >
    Join room
  </button>
</form>
